import { Form, Formik } from "formik";
import { useState, type ReactNode } from "react";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
// @ts-expect-error pure js
import ProfileFormPerso from "../Profile/ProfileFormPerso";
import {
  getMandataireProfileSchema,
  MANDATAIRE_INITIAL_VALUE,
  // @ts-expect-error pure js
} from "../../models/profile";
// @ts-expect-error pure js
import { toInitialValuesFromSchema } from "../../models/utils";
// @ts-expect-error pure js
import MandataireFormFields from "./MandataireFormFields";
// @ts-expect-error pure js
import ProfileFormDom from "../Profile/ProfileFormDom";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
// @ts-expect-error pure js
import Checkbox from "../UI/Checkbox";
import Text from "../UI/Text";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
import type { Mandataire } from "../../models/mandataire";
import styles from "./MandataireForm.module.css";

interface MandataireFormValues {
  profile: { type: string };
  [key: string]: unknown;
}

interface MandataireFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mandataire: Mandataire | null;
  onSubmit: (values: MandataireFormValues) => Promise<void>;
}

export default function MandataireForm({
  open,
  onOpenChange,
  mandataire,
  onSubmit,
}: MandataireFormProps) {
  const [error, setError] = useState<ReactNode>("");
  const validationSchema = getMandataireProfileSchema();

  const initialValues = toInitialValuesFromSchema(
    validationSchema,
    mandataire,
    MANDATAIRE_INITIAL_VALUE,
  );

  async function submitHandler(values: MandataireFormValues) {
    setError("");
    try {
      await onSubmit(values);
    } catch (e) {
      setError(handleAPIError(e));
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
    >
      {({ values, resetForm }) => (
        <ModalDialog
          size="md"
          open={open}
          header={
            mandataire
              ? "Modifier le profil mandataire"
              : "Ajouter un profil mandataire"
          }
          onOpenChange={(nextOpen) => {
            if (!nextOpen) {
              setError("");
              resetForm();
            }
            onOpenChange(nextOpen);
          }}
        >
          <Form>
            <ModalDialogBody>
              <ProfileFormPerso
                type={values.profile.type}
                prefix={"profile."}
                isMandataire
              />
              <ProfileFormDom isMandataire prefix={"profile."} />
              <TextInput
                name={"carte_g"}
                label={"Numéro de carte de gestion"}
                mandatory
              />
              <TextInput
                name={"carte_delivree_par"}
                label={"Organisme ayant délivré la carte de gestion"}
                placeholder={"chambre de commerce et de l’industrie de Paris"}
                mandatory
              />
              <TextInput
                name={"carte_delivree_date"}
                type={"date"}
                label={"Date de délivrance de la carte de gestion"}
                mandatory
              />
              <TextInput
                name={"nom_garant"}
                label={"Nom de l'organisme de garantie"}
              />
              <TextInput
                name={"adresse_garant"}
                label={"Adresse, CP, Ville de l'organisme de garantie"}
              />
              <TextInput
                name={"montant_garanti"}
                type={"number"}
                label={"Montant maximum garanti"}
              />
              <Text>Mentions sur la carte :</Text>
              <div className={styles.mentions}>
                <Checkbox
                  name="carte_mentions"
                  value={"gestion immobilière"}
                  pillStyle
                >
                  Gestion immobilière
                </Checkbox>
                <Checkbox name="carte_mentions" value={"transaction"} pillStyle>
                  Transactions
                </Checkbox>
                <Checkbox
                  name="carte_mentions"
                  value={"syndic de copropriété"}
                  pillStyle
                >
                  Syndic de copropriété
                </Checkbox>
              </div>
              <MandataireFormFields />
              <TextInput
                name={"iban"}
                label={"IBAN du compte de gestion"}
                placeholder={"FR76 XXXX XXXX XXXX XXXX XXXX XXX"}
                subText={
                  "Compte débiteur des fichiers de virement aux mandants (comptabilité pro)."
                }
              />
              <TextInput name={"bic"} label={"BIC du compte de gestion"} />
              <Checkbox name="tva">Assujetti à la TVA</Checkbox>
              <Callout variant="danger">{error}</Callout>
            </ModalDialogBody>
            <ModalDialogFooter>
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </ModalDialogFooter>
          </Form>
        </ModalDialog>
      )}
    </Formik>
  );
}
